<template>
  <div>
    <h3 class="mb-25">Payment overview</h3>
    <div>
      <div class="stat-section">
        <b-row >
          <b-col>
            <div class="stat-box">
              <div class="val-holder">
                <span v-if="overdueInvoices">{{overdueInvoices}} Invoice(s)</span>
                <span v-else>None</span>
              </div>
              <p>Payment overdue</p>
            </div>
          </b-col>
          <b-col>
            <div class="stat-box">
              <div class="val-holder">
                {{avaitingPayment}}
              </div>
              <p>Awaiting Payment</p>
            </div>
          </b-col>
          <b-col>
            <div class="stat-box">
              <div class="val-holder">
                {{unpcomingInvoice}}
              </div>
              <p>Upcoming Invoice</p>
            </div>
          </b-col>
        </b-row>
      </div>

      <div class="table-holder">
        <div class="filters-section">
          <div class="input-holder">
            <i class="icon-search"></i>
            <b-input v-model='searchText' placeholder="Search invoices..."></b-input>
          </div>
          <div class="date-filter-holder">
            <b-dropdown id="ddown1" no-caret :class="{'filter-selected':filterOptionName}">
              <template slot="button-content">
                <span v-if="filterOptionName">
                  <i class="icon-calendar"></i>
                  <span class="filter-name">{{filterOptionName}}</span>
                  <i @click="clearFilter" class="icon-close"></i>
                </span>
                <span v-else>
                  <i class="icon-invoice-type"></i>
                  <span>Filter by status</span>
                </span>
              </template>
              <template v-for="option in filterOptions">
                <b-dropdown-item @click="filterOption=option" :key="option.id">{{option.name}}</b-dropdown-item>
              </template>
            </b-dropdown>
          </div>
        </div>

        <div v-if="invoicesLoading" class="loading-overlay"><server-processing :serverIsBusy="invoicesLoading" :localSpinner="true"/></div>


        <b-table v-if="items.length"
                 :items="itemsPage"
                 :fields="fields"
                 responsive
        >
          <template v-slot:cell()="data">
            <div class="value-box">
              {{ data.value }}
            </div>
          </template>
          <template v-slot:cell(report_id)="data">
            <a href="#" class="link-box" v-if="data.value" @click.stop.prevent="openInvoice(data.item)" target="_blank"><i class="icon-links"></i>View Invoice</a>
          </template>
          <template v-slot:cell(StatusShort)="data">
            <div v-html="data.value"></div>
          </template>
          <template v-slot:cell(InvoiceID)="data">
            <button class="link-box" @click.stop.prevent="openInvoice(data.value)"><i class="icon-invoice"></i>View Invoice</button>
          </template>
        </b-table>

        <div class="pagination-holder pagination-group">
          <div v-if="totalPages&&totalPages>0">
            <b-pagination-nav
                    base-url="#"
                    :number-of-pages="totalPages"
                    v-model="selectedPage"
                    align="center"
            >
              <template slot="first-text"><i class="icon-double-arrow-left"></i></template>
              <template slot="prev-text"><i class="icon-single-arrow-left"></i></template>
              <template slot="next-text"><i class="icon-single-arrow-right"></i></template>
              <template slot="last-text"><i class="icon-double-arrow-right"></i></template>
            </b-pagination-nav>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
import moment from 'moment';
import helpers from '../_mixins/helpers';
import axios from '../_helpers/axios';
import { apiUrl } from 'config';

export default {
  name: 'InvoicesTable',
  mixins: [helpers],
  data: () => ({
    searchText: '',
    selectedPage: 1,
    totalPages: 1,
    rowsPerPage: 10,
    fields: [
      {
        key: 'InvoiceNumber',
      },
      {
        key: 'DateString',
        label: 'Date Sent',
        sortable: true,
        variant: 'date',
        formatter: (value) => {
          return moment(value).format('DD MMM YYYY');
        }
      },
      {
        key: 'DueDateString',
        label: 'Date Due',
        sortable: true,
        variant: 'date',
        formatter: (value) => {
          return moment(value).format('DD MMM YYYY');
        }
      },
      {
        key: 'Total',
        label: 'Amount',
        variant: 'center',
        formatter: (value) => {
          return value.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        }
      },
      {
        key: 'CurrencyCode',
        label: 'Currency',
        variant: 'center',
      },
      {
        key: 'StatusShort',
        variant: 'center',
        formatter: (value) => {
          if (value==='Paid') return '<span class="status-paid">Paid</span>'
          else if (value==='Unpaid') return '<span class="status-unpaid">Unpaid</span>'
          else return '<span class="status-overdue">Overdue</span>';
        }
      },
      {
        key: 'InvoiceID',
        label: '',
      },
    ],
    filterOptions: [
      {
        id: 0,
        name: 'Unpaid',
      },
      {
        id: 1,
        name: 'Overdue',
      },
      {
        id: 2,
        name: 'Paid',
      },
    ],
    filterOption: -1,

  }),
  methods: {
    clearFilter() {
      this.filterOption = -1;
    },
    async openInvoice(id) {
      const url = await axios.get(`${apiUrl}/api/services/getInvoiceUrl?id=${id}`);
      window.open(url , '_blank');
    }
  },
  computed: {
    invoicesLoading() {
      return this.$store.state.campaigns.invoices.loading || false;
    },
    itemsPage() {
      let allItems = this.items;
      if (allItems && allItems.length) {
        const begin = (this.selectedPage - 1) * this.rowsPerPage;
        allItems = allItems.slice(begin, begin + this.rowsPerPage);
      }

      return allItems;
    },
    items() {
      let allItems = this.$store.state.campaigns.invoices || [];
      if (!allItems.length) {
        return [];
      }

      allItems = allItems.sort((a,b)=>{
        return a.DateString > b.DateString ? -1 : 1;
      });

      allItems = allItems.map(e=>{
        e.DateFormatted = moment(e.DateString).format('DD MMM YYYY');
        if (e.Status==='PAID') {
          e.StatusShort = 'Paid';
        } else if (new Date(e.DueDateString)>new Date()) {
          e.StatusShort = 'Unpaid';
        } else {
          e.StatusShort = 'Overdue';
        }
        return e;
      });

      if (this.selectedFilterOption>-1) {
        allItems = allItems.filter(e=>e.StatusShort===this.filterOptionName);
      }
      if (this.searchText) {
        allItems = allItems.filter(e=>e.InvoiceNumber.toLowerCase().indexOf(this.searchText.toLowerCase())>=0);
      }

      return allItems;
    },
    selectedFilterOption() {
      return this.filterOption.id;
    },
    user() {
      return this.$store.state.authentication.user;
    },
    filterOptionName() {
      if (this.filterOption!==-1) return this.filterOption.name;
      return '';
    },
    overdueInvoices() {
      let invoices = this.items;
      invoices = invoices.filter(e=>e.StatusShort==='Overdue');
      return invoices.length;
    },
    avaitingPayment() {
      let invoices = this.items;
      invoices = invoices.filter(e=>e.StatusShort!=='Paid');
      let sum = invoices.reduce((acc,e)=>{
        acc += e.Total;
        return acc;
      },0)
      return '$ '+sum.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
    },
    unpcomingInvoice() {
      let invoices = this.items;
      invoices = invoices.filter(e=>e.StatusShort!=='Paid');
      if (invoices.length) {
        return invoices[invoices.length-1].InvoiceNumber;
      }
      return 'None';
    },
  },
  watch: {
    selectedFilterOption(newVal) {
      if (newVal>-1) {
        this.selectedPage = 1;
      }
    },
    searchText(newVal) {
      if (newVal) {
        this.selectedPage = 1;
      }
    },
    items() {
      this.totalPages = Math.max(
        1,
        Math.round(
          this.items.length / Math.max(1, this.rowsPerPage)
        )
      );
    }
  }

};
</script>

<style scoped lang="scss">
@import '../assets/_scss/_component-base';
@import '../assets/_scss/components/pagination';

.loading-overlay {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

.stat-section {
  margin-bottom: 30px;
  @include sm {
    flex-wrap: wrap;
    box-shadow: 0 0 10px 6px rgba(0,0,0,0.1);
    border-radius: 10px;
  }
  @include xs {
    >.row {
      margin-left: -10px;
      margin-right: -10px;
      >.col {
        padding-left: 10px;
        padding-right: 10px;
      }
    }
  }
  .col {
    @include sm {
      flex-basis: 100%;
      position: relative;
      &:not(:last-child) {
        &:after {
          content: '';
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          display: block;
          background: $lgrey3;
          width: 90%;
          height: 1px;
          opacity: .5;
          margin: auto;
        }
      }
    }
  }
  .stat-box {
    background: #fff;
    box-shadow: 0 0 10px 6px rgba(0,0,0,0.1);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 20px;
    border-radius: 6px;
    @include sm {
      box-shadow: none;
    }
    p {
      color: $lgrey;
    }
  }
  .val-holder {
    font-weight: 600;
    font-size: 26px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;
    position: relative;
  }
}

.table-holder {
  background: #fff;
  border-radius: 6px;
  box-shadow: 0 0 10px 6px rgba(0,0,0,0.1);
  padding: 20px;
  position: relative;
}

.filters-section {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
  @include xs {
    flex-direction: column;
  }
  .input-holder {
    position: relative;
    width: 524px;
    max-width: 100%;
    input {
      padding-left: 45px;
    }
    i {
      font-size: 18px;
      color: $lgrey;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 15px;
      height: 100%;
      margin: auto;
      display: flex;
      align-items: center;
    }
  }
  .date-filter-holder {
    color: $text-muted;
    @include md {
      margin-left: 15px;
    }
    @include xs {
      margin-left: 0;
      margin-top: 15px;
    }
    .b-dropdown {
      &.filter-selected {
        pointer-events: none;
        .icon-close {
          pointer-events: auto;
        }
      }
    }
    .filter-name {
      margin-right: 10px;
    }
    i {
      margin-right: 10px;
      font-size: 16px;
      &.icon-close {
        font-size: 12px;
        color: $dark;
        cursor: pointer;
      }
    }
    /deep/ button {
      background: $lgrey2;
      color: inherit;
      padding: 10px;
      font-weight: 400;
      &:active {
        background: $lgrey2;
        color: inherit;
      }
    }
  }
}

/deep/ .table.b-table {
  .table-date {
    max-width: 120px;
    width: 120px;
  }
  .table-center {
    text-align: center;
  }
  .status-paid {
    color: $success;
  }
  .status-unpaid {
    color: $lgrey;
  }
  .status-overdue {
    color: $error;
  }
  >thead >tr {
    >th {
      vertical-align: middle;
      padding: 10px 30px 10px 0;
      &[aria-sort]:not(.b-table-sort-icon-left) {
        padding: 10px 30px 10px 0;
        background-position: right 15px center;
      }
      text-transform: uppercase;
      /*text-align: center;*/
      color: $lgrey;
      font-weight: 500;
      line-height: 1;
    }
  }
  td {
    padding: 10px 15px 10px 0;
    vertical-align: middle;
  }
  th, td {
    border: none;
  }
  tr {
    border-bottom: 1px solid $lgrey6;
  }
  .value-box {
    padding-right: 15px;
  }
  .link-box {
    border: none;
    width: 100%;
    color: $text-color;
    background: $warning-lt;
    white-space: nowrap;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px 12px;
    border-radius: 4px;
    i {
      margin-right: 10px;
    }
  }
}

</style>
